import React from "react";
import { ContactContainer, ContactImg, ContactLink, ContactsContainer, FooterBottomContainer, FooterContainer, FooterContentContainer, IcoElem, LocationText, LogoContainer, LogoImg } from "./styled";

import EmailImg from "../../images/Footer/email.svg";
import MapImg from "../../images/Footer/map.svg";
import PhoneImg from "../../images/Footer/phone.svg";

const SpecialFooter = () => {
  return (
    <FooterContainer>
      <FooterContentContainer>
        <ContactsContainer>
          <ContactContainer>
            <ContactImg src={PhoneImg} alt="Obrázek znázorňující telefon" />
            <ContactLink href="tel:+420739235235">+420 739 235 235</ContactLink>
          </ContactContainer>
          <ContactContainer>
            <ContactImg src={MapImg} alt="Obrázek znázorňující lokaci" />
            <LocationText>RPK TECHNIK s.r.o Všeradice 96, 267 26</LocationText>
          </ContactContainer>
          <ContactContainer>
            <ContactImg src={EmailImg} alt="Obrázek znázorňující poštovní obálku" />
            <ContactLink href="mailto: servis@rpktechnik.cz">servis@rpktechnik.cz</ContactLink>
          </ContactContainer>
        </ContactsContainer>
        <LogoContainer>
          <LogoImg src={"/images/ContactForm/originalLogo.svg"} alt="Logo firmy RPK Technik" />
          <IcoElem>IČO: 07676107 / DIČ: CZ07676107</IcoElem>
        </LogoContainer>
      </FooterContentContainer>
      <FooterBottomContainer>
        <p>Zapsán v obchodním rejstříku vedeném Městským soudem v Praze, oddíll C, vložka 305273</p>
      </FooterBottomContainer>
    </FooterContainer>
  );
};

export default SpecialFooter;
